<button data-testid="auto-app-email-campaign-google-button-button-1" class="reset-button c-btn px-5 py-3" (click)="connectoGmail()">
  <div class="align-items-center d-flex">
    <div class="d-flex justify-content-center align-items-center">
      <img src="assets/images/google.png" alt="Gmail" class="mr-2" style="aspect-ratio: 1;" width="22" />
    </div>
    <span>Continue with google</span>
  </div>
</button>